import * as types from '../actions/actionTypes';
import initialState from "./initialState";

export function branchReducer(
  state = initialState.branch, action
) {
  switch (action.type) {
    case types.FETCH_BRANCH_SUCCESS:
        return action.branch;
    default:
        return state;
  }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/userReducer.js